import type { DocumentTagsFragment } from "../client/generated";
import { Badge } from "@acdc2/ui/components/badge";

type Props = {
  fragment: DocumentTagsFragment;
};

export function DocumentTags({ fragment }: Props) {
  if (fragment.tags.length === 0) {
    return <></>;
  }

  return (
    <div className="flex flex-wrap gap-x-1 gap-y-2">
      {fragment.tags.map((tag) => (
        <Badge key={tag} variant="outline">
          {tag}
        </Badge>
      ))}
    </div>
  );
}
